import client from './client';

export const mediaApi = {
  list: (params) => client.get('/media', { params }),
  get: (id) => client.get(`/media/${id}`),
  upload: (file, altText) => {
    const formData = new FormData();
    formData.append('file', file);
    if (altText) formData.append('alt_text', altText);
    return client.post('/media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  update: (id, data) => client.put(`/media/${id}`, data),
  delete: (id) => client.delete(`/media/${id}`),
};
